<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="12">
        <div class="item-title">佣金汇总</div>
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="stat-item">
            <div class="icon">
              <a-icon type="rise" />
            </div>
            <div class="value-content">
              <div class="value"><span class="small">￥</span> {{info.total_commission}}</div>
              <div class="label">累计收益</div>
            </div>
          </div>
          
          </a-col>
          <a-col :span="12">
            <div class="stat-item success">
              <div class="icon">
                <a-icon type="money-collect" />
              </div>
              <div class="value-content">
                <div class="value"><span class="small">￥</span> {{info.commission}}</div>
                <div class="label">可提现</div>
              </div>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="16" style="margin-top:20px">
          <a-col :span="12">
            <div class="stat-item transparent">
              <div class="value-content">
                <div class="value"><span class="small">￥</span> {{info.estimate_commission}}</div>
                <div class="label">预计收益</div>
              </div>
            </div>
          
          </a-col>
          <a-col :span="12">
            <div class="stat-item transparent">
              <div class="value-content">
                <div class="value"><span class="small">￥</span> {{info.today_commission}}</div>
                <div class="label">今日收益</div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="stat-item transparent">
            <div class="value-content">
              <div class="value">{{info.today_click}}</div>
              <div class="label">今日点击</div>
            </div>
          </div>
          
          </a-col>
          <a-col :span="12">
            <div class="stat-item transparent">
              <div class="value-content">
                <div class="value">{{info.total_click}} </div>
                <div class="label">累计点击</div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="12">
        <div class="item-title">最近半年动态</div>
        <div id="myChart" :style="{height:'230px', width:'467px', background:'rgba(255,255,255,0.05)', 'border-radius':'10px' }"></div>
      </a-col>
    </a-row>

    <div class="month-box">
      <div class="item-title">最近7天明细</div>
      <a-table :columns="columns" :data-source="info.near_7_days" size="middle" row-key="date" :pagination="false" class="transpanret-table"></a-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core';
import { GridComponent, TooltipComponent } from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([GridComponent,TooltipComponent, LineChart, CanvasRenderer, UniversalTransition]);
const columns = [
  {
    title: '日期',
    dataIndex:'date'
  },
  {
    title: '点击量',
    dataIndex: 'click_count',
  },
  {
    title: '订单数量',
    dataIndex: 'order_count',
  },
  {
    title: '收益',
    dataIndex: 'commission',
  }
];
let self;
export default {
  name: '',
  data(){
    return {
      columns,
      warningVisible:true,
      info:{
        
      }
    }
  },
  mounted(){
    self = this;
    this.getStatInfo();
  },
  methods:{
    getStatInfo(){
      this.$http.get('getStatInfo').then((res)=>{
        self.info = res.data;
        self.drawLine();
      })
    },
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('myChart'))
        // 绘制图表
        let data = [];
        let countData = [];
        for(let i in this.info.near_6_months){
          data.push(i);
          countData.push(this.info.near_6_months[i]);
        }
        
        myChart.setOption({
            tooltip: {},
            xAxis: {
                data: data,
                axisLine:{
                  color:'#111'
                }
            },
            yAxis: {},
            series: [{
                name: '收益',
                type: 'line',
                color:'#4f46bb',
                smooth: true,
                data: countData
            }]
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import '../assets/reset.less';
  .item-title{
    color: #fff;
    margin-bottom: 1rem;
  }

  .stat-item{
    display: flex;
    background: #222338;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
  }

  .stat-item .icon{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 5px solid @primary-color;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    box-shadow: 0 0 10px @primary-color;
    color: #fff;
  }
  .stat-item.warning .icon{
    border: 5px solid @warning-color;
    box-shadow: 0 0 10px @warning-color;
  }
  .stat-item.success .icon{
    border: 5px solid @success-color;
    box-shadow: 0 0 10px @success-color;
  }
  .stat-item .value-content .value{
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: fantasy;
  }
  .stat-item .value-content .label{
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
  }
  .stat-item.transparent{
    background: none;
  }
  .stat-item.transparent .value{
    font-family: cursive;
  }

  .month-box{
    margin-top: 30px;
  }
</style>
